/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Five_PlusInputs */

const cs_enum_five_plus = /** @type {(inputs: Enum_Five_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5+`)
};

const en_enum_five_plus = /** @type {(inputs: Enum_Five_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5+`)
};

/**
* | output |
* | --- |
* | "5+" |
*
* @param {Enum_Five_PlusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_five_plus = /** @type {((inputs?: Enum_Five_PlusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Five_PlusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_five_plus(inputs)
	return cs_enum_five_plus(inputs)
});